import { styled } from '@styles/stitches';

export const Container = styled('div', {
  position: 'relative',
  display: 'flex',
  flexDirection: 'column',
});

export const Media = styled('div', {
  display: 'flex',
  alignItems: 'flex-start',
  justifyContent: 'center',

  '@bp1': {
    alignItems: 'center',
    height: 'calc(var(--app-height) - 64px - $space$1)',
  },

  '&:fullscreen': {
    height: 'var(--app-height)',

    '&>*:first-child': {
      maxHeight: 'var(--app-height)!important',
    },
  },
});

export const Info = styled('div', {
  width: '100%',
  zIndex: 1,

  '@bp1': {
    width: 'calc(100% - 350px - 64px)',
    marginRight: '$space$1',
  },
});

export const Purchase = styled('div', {
  display: 'flex',
  width: '100%',

  '@bp1': {
    paddingTop: 41,
    width: 350,
  },
});
